import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface PublicPageShellProps {
  children: ReactNode
  className?: string
  contentClassName?: string
  scrollMode?: 'self' | 'parent'
}

export function PublicPageShell({
  children,
  className,
  contentClassName,
  scrollMode = 'self',
}: PublicPageShellProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-col bg-muted/30',
        scrollMode === 'self'
          ? 'min-h-dvh overflow-y-auto overscroll-contain'
          : 'min-h-full overflow-visible',
        className
      )}
      data-public-page-shell
    >
      <div
        className={cn(
          'flex w-full flex-1 items-center justify-center p-4 sm:p-6',
          scrollMode === 'self' ? 'min-h-dvh' : 'min-h-full',
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  )
}
